declare global {
  interface Window {
    vfAfterStorefrontReady?: (task: () => void) => void;
  }
}

// Available before GTM starts. Optional recording waits for Vue's initial
// mount, load (including above-fold images), a paint, and main-thread idle.
// Google measurement, consent commands, and ecommerce queues do not wait.
export function installOptionalAnalyticsScheduler(): () => void {
  const tasks: (() => void)[] = [];
  let mounted = false;
  let loaded = document.readyState === "complete";
  let scheduled = false;
  const drain = () => {
    scheduled = false;
    if (document.visibilityState === "hidden") return;
    const task = tasks.shift();
    try {
      task?.();
    } catch {
      /* Optional analytics cannot break shopping. */
    }
    schedule();
  };
  const schedule = () => {
    if (
      !mounted ||
      !loaded ||
      scheduled ||
      !tasks.length ||
      document.visibilityState === "hidden"
    )
      return;
    scheduled = true;
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        if (document.visibilityState === "hidden") {
          scheduled = false;
          return;
        }
        if ("requestIdleCallback" in window)
          window.requestIdleCallback(drain, { timeout: 1500 });
        else window.setTimeout(drain, 50);
      })
    );
  };
  window.vfAfterStorefrontReady = (task) => {
    tasks.push(task);
    schedule();
  };
  window.addEventListener(
    "load",
    () => {
      loaded = true;
      schedule();
    },
    { once: true }
  );
  document.addEventListener("visibilitychange", schedule);
  return () => {
    mounted = true;
    schedule();
  };
}
